import React, { useLayoutEffect, useState } from 'react';
import { combineClassNames } from '../../../../app/functions';
import closeIconPath from '../../../../assets/icons/login-x-icon.svg';
import './index.scss';

const ImagePopup = ({ image, handleClose }) => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);

  const openPopup = () => {
    setTimeout(() => {
      setIsPopupVisible(true);
    }, 250);
  }

  const closePopup = () => {
    setIsPopupVisible(false);
    setTimeout(handleClose, 250);
  };

  const handleBackdropClick = ({ target }) => {
    // Close popup only if backdrop was clicked, not its children
    if (target.classList.contains('backdrop')) {
      closePopup();
    }
  };

  useLayoutEffect(openPopup, []);

  return (
    <div
      className={combineClassNames(
        'backdrop',
        isPopupVisible && 'active',
      )}
      onClick={handleBackdropClick}
    >
      <div className="image-popup">
        <button
          type="button"
          className="popup-close-button"
          onClick={closePopup}
          aria-label="Close Popup"
        >
          <img src={closeIconPath} alt="Close Icon" />
        </button>
        <img src={image.src} alt={image.alt} className="image-element" />
      </div>
    </div>
  );
};

export default ImagePopup;
